
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./src/client/index.ts";
              export default OriginalModule.default;
              export * from "./src/client/index.ts";